import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { GetGrowthReportData, GetGrowthReportEvent, GetGrowthReportResult } from 'bloggers-backend/lib/bloggers/domain';
import { AppContext } from '../AppContext';

export function useGrowthReport(request: GetGrowthReportData, enabled: boolean) {
  const { client } = useContext(AppContext);

  return useQuery(
    ['growthReport', request.granularity, request.status, request.startDate, request.endDate],
    async () => {
      const result = await client<GetGrowthReportEvent, GetGrowthReportResult>({
        event: 'Blogger.getGrowthReport',
        data: request,
      });
      if (!result.success) {
        throw new Error(result.reason);
      }
      return result.value;
    },
    { enabled }
  );
}
